import React, { useEffect, useState } from 'react';
import { getService } from '@Client/runner.hooks/useService';
import './FlowInstructionHistory.scss';

type FlowInstructionHistoryProps = {
  instruction?: string;
  isMobile?: boolean;
};

export const FlowInstructionHistory = ({
  instruction,
  isMobile
}: FlowInstructionHistoryProps) => {
  const [instructionText, setInstructionText] = useState<string>('');

  useEffect(() => {
    if (!instruction) {
      setInstructionText('');
      return;
    }

    const validationService = getService('validationService');
    const fileService = getService('fileService');

    const sanitizedHtml = validationService.sanitizeString(instruction);
    setInstructionText(sanitizedHtml);

    fileService
      .replaceFileIdsWithImages(instruction)
      .then((result) => {
        const sanitizedResult = validationService.sanitizeString(result);
        setInstructionText(sanitizedResult);
      })
      .catch(() => {
        // Keep the initially sanitized text if file replacement fails
      });
  }, [instruction]);

  return (
    <div className="instruction-field-wrapper instruction-field-wrapper--history">
      <div className="instruction-field instruction-field--history">
        <div
          className={`p-0 of-h ${isMobile ? 'isMobile' : ''}`}
          dangerouslySetInnerHTML={{ __html: instructionText }}
        />
      </div>
    </div>
  );
};
